import React from 'react'

export default function SuccessNotificationIcon() {
    return (
        <svg width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#12B76A" />
            <path d="M32 18L21 29L16 24" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
